<div class="unauthorized-container">
  <div class="unauthorized-content">
    <h1>🚫 Access Denied</h1>
    <p>{{AccessDenied}}</p>
  </div>
</div>

